import { onElementsAvailable } from 'src/utils/onElements'

const handleIntersection = entries =>
  entries.forEach(entry =>
    entry.isIntersecting
    ? entry.target.nextElementSibling?.removeAttribute('stuck')
    : entry.target.nextElementSibling?.setAttribute('stuck', '')
  )

const init = () => {
  // Skip browsers that don't support position: sticky
  const element = document.createElement('div')
  element.style.position = 'sticky'
  if (!element.style.position) return

  // Observe both the .sticky-measure elements present at load and any added
  // later (e.g. by a React app that mounts after DOMContentLoaded).
  const observer = new IntersectionObserver(handleIntersection)
  onElementsAvailable('.sticky-measure', e => observer.observe(e))
}

document.addEventListener('DOMContentLoaded', init)
